import { render, staticRenderFns } from "./archivos.vue?vue&type=template&id=6c9b12de"
import script from "./archivos.vue?vue&type=script&lang=js"
export * from "./archivos.vue?vue&type=script&lang=js"
import style0 from "./archivos.vue?vue&type=style&index=0&id=6c9b12de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports